import { useEffect, useState } from "react";
import { Users, MessageSquare, Clock, TrendingUp, Layers, CheckCircle2, ShieldCheck, MessageSquareText } from "lucide-react";
import api, { inr } from "@/lib/api";

const Card = ({ icon: Icon, label, value, sub, accent, testId, onClick }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className={`text-left bg-[#0A0A0A] p-6 border border-white/10 hover:border-[#D4AF37]/50 transition-colors ${accent ? "border-[#D4AF37]/40" : ""}`}
  >
    <div className="flex items-center justify-between">
      <p className="font-accent text-[9px] tracking-[0.25em] uppercase text-white/40">{label}</p>
      <Icon size={14} className={accent ? "text-[#D4AF37]" : "text-white/30"} />
    </div>
    <p className={`font-display text-3xl mt-3 ${accent ? "text-[#D4AF37]" : "text-white"}`}>{value}</p>
    {sub && <p className="text-[11px] text-white/35 mt-1">{sub}</p>}
  </button>
);

export const Overview = ({ onNavigate, refreshKey }) => {
  const [s, setS] = useState(null);
  useEffect(() => {
    api.get("/admin/stats").then((r) => setS(r.data)).catch(() => {});
  }, [refreshKey]);
  if (!s) return <div className="h-28 border border-white/10 animate-pulse mb-12" data-testid="admin-overview-loading" />;
  return (
    <div className="grid sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-8 gap-px bg-white/5 border border-white/10 mb-12" data-testid="admin-overview">
      <Card icon={Clock} label="Pending approvals" value={s.pending} sub={`${inr(s.pending_amount)} awaiting`} accent={s.pending > 0} testId="stat-pending" onClick={() => onNavigate("investments", "pending")} />
      <Card icon={MessageSquareText} label="Support" value={s.support_unread} sub="unread questions" accent={s.support_unread > 0} testId="stat-support" onClick={() => onNavigate("support")} />
      <Card icon={ShieldCheck} label="KYC to verify" value={s.kyc_pending} sub="PAN / Aadhaar pending" accent={s.kyc_pending > 0} testId="stat-kyc-pending" onClick={() => onNavigate("kyc")} />
      <Card icon={TrendingUp} label="Active capital" value={inr(s.active_amount)} sub={`${s.investments_total} total requests`} testId="stat-active-amount" onClick={() => onNavigate("investments", "active")} />
      <Card icon={CheckCircle2} label="Completed" value={inr(s.completed_amount)} sub="matured & paid out" testId="stat-completed-amount" onClick={() => onNavigate("investments", "completed")} />
      <Card icon={Users} label="Investors" value={s.investors} sub={`+${s.new_investors_week} this week`} testId="stat-investors" onClick={() => onNavigate("investors")} />
      <Card icon={MessageSquare} label="Enquiries" value={s.enquiries} sub={`+${s.new_enquiries_week} this week`} testId="stat-enquiries" onClick={() => onNavigate("enquiries")} />
      <Card icon={Layers} label="Live plans" value={s.plans} sub="visible on site" testId="stat-plans" onClick={() => onNavigate("plans")} />
    </div>
  );
};
